import React, { Component } from 'react';

class CompanyRow extends Component {
  render() {
    return (
      <div key={this.props.id} class="row show-grid">
        <div class="col-md-12">
          <div class="card text-left" >
            <div class="card-body">
              <div container>
                <div class="row show-grid">
                  <div class="col-md-3">
                    <a target="_blank" rel="noopener noreferrer" href={this.props.website}>
                      <h5 style={{'margin-bottom': 0}}>{this.props.name}</h5>
                    </a>
                    <small>
                      {
                        //TODO on click add search tag
                        !this.props.tags ? "" : this.props.tags.join(", ")
                      }
                    </small>
                  </div>
                  <div class="col-md-7">
                    <p class="card-text">{this.props.description}</p>
                  </div>
                  <div class="col-md-2">
                    <a target="_blank" rel="noopener noreferrer" href={this.props.jobs} class="btn btn-primary">Jobs</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }
}

export default CompanyRow;
